export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/pin-bottom.e006866d-44dc4b.svg";